import { createBrowserHistory } from "history";

const h = createBrowserHistory({});
export default h;
